import { post } from '@ug/utils';

export const dayuLogin = async (data = {}) => await post('/mapi/login/dayu-login', data);
